export default function spamBotProtection() {
  if (document.querySelector('#humanity_proof')) {
    document.querySelector('#humanity_proof').value = "I'm a human"
  }
}
